import { useState } from 'react'
import PropTypes from 'prop-types'

import Navbar from 'components/Layout/Navbar'
import Sidebar from 'components/Layout/Sidebar'
import TopNavbar from 'components/Layout/TopNavbar'

const Main = ({
  navbarContent,
  mainContent,
  isSidebar,
  isBannerOpen,
}) => {
  const [sidebarActive, setSideBarActive] = useState(false)

  const toggleSidebarActive = () => {
    setSideBarActive(!sidebarActive)
  }

  return (
    <>
      <TopNavbar
        toggleSidebarActive={toggleSidebarActive}
        isBanner={isBannerOpen}
      />
      <Navbar isBanner={isBannerOpen}>{navbarContent}</Navbar>
      {isSidebar && (
        <Sidebar
          isOpen={sidebarActive}
          toggleSidebarActive={toggleSidebarActive}
          isBanner={isBannerOpen}
        />
      )}
      <main className="layout">{mainContent}</main>
    </>
  )
}

Main.defaultProps = {
  isSidebar: true,
}

Main.propTypes = {
  navbarContent: PropTypes.node,
  mainContent: PropTypes.node,
  isSidebar: PropTypes.bool,
}

export default Main
